import { render, staticRenderFns } from "./ComponentDashboard.vue?vue&type=template&id=2895f17b&"
import script from "./ComponentDashboard.vue?vue&type=script&lang=js&"
export * from "./ComponentDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2895f17b')) {
      api.createRecord('2895f17b', component.options)
    } else {
      api.reload('2895f17b', component.options)
    }
    module.hot.accept("./ComponentDashboard.vue?vue&type=template&id=2895f17b&", function () {
      api.rerender('2895f17b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ComponentDashboard.vue"
export default component.exports